import { graphql, HttpResponse } from 'msw'
import { type EnrollmentJointContactInfoData, type EnrollmentJointContactInfoSubmitOutput } from '../../../../models'

export const getEnrollmentJointContactInfoDataMock: EnrollmentJointContactInfoData = {
  accountType: 'JOINT_COMMUNITY_PROPERTY',
  activePerson: {
    applicationId: '1234567890',
    path: '/enrollment/joint/get-started',
    progress: 100,
    email: 'test@test.com',
    isInitiator: true,
    name: {
      firstName: '',
      lastName: '',
    },
    phone: {
      countryPhoneCode: 1,
      phoneNumber: '8044250000',
    },
  },
  isError: false,
  error: '',
  jointPerson: {
    email: 'test@test.com',
    name: {
      firstName: 'Test',
      lastName: 'Test',
    },
    phone: {
      countryPhoneCode: 1,
      phoneNumber: '8044250000',
    },
  },
}

export const submitEnrollmentJointContactInfoDataMock: EnrollmentJointContactInfoSubmitOutput = {
  isError: false,
  error: '',
  activePerson: {
    path: '/enrollment/joint/verify-email',
  },
}

export const mockGetEnrollmentJointContactInfoData = graphql.mutation('getEnrollmentJointContactInfoData', () => {
  return HttpResponse.json({ data: { submitJointEnrollment: getEnrollmentJointContactInfoDataMock } })
})

export const mockSubmitEnrollmentJointContactInfoData = graphql.mutation('submitEnrollmentJointContactInfoData', () => {
  return HttpResponse.json({ data: { submitJointEnrollment: submitEnrollmentJointContactInfoDataMock } })
})

export const mockEnrollmentJointContactInfo = [
  mockGetEnrollmentJointContactInfoData,
  mockSubmitEnrollmentJointContactInfoData,
]
